const ORGANIZATIONAL_DOCUMENT_TYPES = {
  ARTICLES_OF_INCORPORATION: {
    value: "articles_of_incorporation",
    readableName: "Articles of Incorporation",
  },
  ARTICLES_OF_ORGANIZATION: {
    value: "articles_of_organization",
    readableName: "Articles of Organization",
  },
  ARTICLES_OF_ASSOCIATION: {
    value: "articles_of_association",
    readableName: "Articles of Association",
  },
  PARTNERSHIP_AGREEMENT: {
    value: "partnership_agreement",
    readableName: "Partnership Agreement",
  },
  OPERATING_AGREEMENT: {
    value: "operating_agreement",
    readableName: "Operating Agreement",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

// Convert the object to an array of entries
export const organizationalDocumentTypesArray = Object.values(ORGANIZATIONAL_DOCUMENT_TYPES);
